<template>
  <div class="g-content">
    <!-- 按钮区域 -->
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <h3>{{ $t('application_menu') }}</h3>
        <!-- 添加 -->
        <router-link
          :to="{ name: 'ApplicationAdd' }"
          style="display: flex;"
          v-if="AUTH_APPLICATION_ADD"
        >
          <a-button type="primary">
            {{ $t('com_btn_add') }}
          </a-button>
        </router-link>
      </div>
    </div>

    <div class="g-content-main common-filter-main">
      <div class="g-table">
        <Loading :show="true" v-if="loading" />
        <NetworkError v-else-if="networkError" style="margin-top:0;" />
        <a-table
          :columns="columns"
          :data-source="list"
          bordered
          :rowKey="(_text, index) => index"
          :pagination="false"
          :loading="tableLoading"
          v-else
        >
          <!-- 应用名称  -->
          <template slot="name" slot-scope="text, record">
            <span class="g-table-text">
              <router-link
                :to="{ name: 'ApplicationDetail', params: { id: record.id } }"
                v-if="AUTH_APPLICATION_DETAIL"
              >
                {{ text }}
              </router-link>
              <span v-else>
                {{ text }}
              </span>
            </span>
          </template>

          <!-- 状态 -->
          <template slot="Status" slot-scope="text">
            <ApplicationStatus :status="text" />
          </template>

          <!-- 安装日期  -->
          <template slot="installTime" slot-scope="date">
            {{ date | formatDate('yyyy-MM-dd') }}
          </template>

          <!-- 操作栏 -->
          <template slot="Action" slot-scope="text, record">
            <div class="application-table-action">
              <!-- 编辑 -->
              <a-button
                type="primary"
                class="ant-btn-ellipsis"
                @click="
                  () =>
                    $router.push({
                      name: 'ApplicationUpdate',
                      params: { id: record.id },
                    })
                "
                v-if="AUTH_APPLICATION_EDIT"
              >
                <Icon type="edit" />
              </a-button>

              <!-- 删除 -->
              <a-button
                type="red"
                class="ant-btn-ellipsis"
                @click="remove($event, record)"
                v-if="AUTH_APPLICATION_DELETE"
              >
                <Icon type="delete" />
              </a-button>

              <a-popover
                trigger="hover"
                placement="bottom"
                overlayClassName="custom-popover-menu custom-popover-noarrow"
                v-if="AUTH_APPLICATION_ENABLE_DISABLE"
              >
                <template slot="content">
                  <ul class="g-ellipsis-menu">
                    <!-- 已禁用 -->
                    <li @click="setStatus(record, true)" v-if="record.status === 0">
                      <ins><a-icon type="play-circle"/></ins>
                      <span>{{ $t('com_btn_enabled2') }}</span>
                    </li>

                    <!-- 已启用 -->
                    <li @click="setStatus(record, false)" v-else>
                      <ins>
                        <Icon type="forbidden2" />
                      </ins>
                      <span>{{ $t('com_btn_disabled2') }}</span>
                    </li>
                  </ul>
                </template>
                <a-button type="primary" class="ant-btn-ellipsis">
                  <Icon type="ellipsis" />
                </a-button>
              </a-popover>
            </div>
          </template>
        </a-table>

        <Pagination
          :current="pagination.current"
          :total="pagination.total"
          :pageSize.sync="pagination.pageSize"
          :callback="getList"
          @change="getList"
        />
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/application';
import ApplicationStatus from '@/views/application/components/Status';
import applicationAuth from '@/views/application/mixins/applicationAuth';

export default {
  mixins: [applicationAuth],
  components: {
    ApplicationStatus,
  },
  data() {
    return {
      loading: true,
      tableLoading: false,

      columns: [
        {
          title: '#',
          align: 'center',
          width: 60,
          customRender: (text, record, index) => {
            return (this.pagination.current - 1) * this.pagination.pageSize + (index + 1);
          },
        },
        {
          title: this.$t('application_table_name'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
        },

        {
          title: this.$t('customer_title'),
          dataIndex: 'bindUserName',
        },

        {
          title: this.$t('com_table_status'),
          dataIndex: 'status',
          align: 'center',
          scopedSlots: { customRender: 'Status' },
        },

        {
          title: this.$t('application_table_installation_date'),
          dataIndex: 'installTime',
          scopedSlots: { customRender: 'installTime' },
        },
      ],
      list: [],
      // 分页
      pagination: {
        // 当前页码
        current: Number(this.$route.query.pageNo) || 1,
        // 每页显示
        pageSize: 10,
        // 记录总条数
        total: 0,
      },

      networkError: false,
    };
  },
  created() {
    this.getData();

    // 权限
    if (
      this.AUTH_APPLICATION_EDIT ||
      this.AUTH_APPLICATION_DELETE ||
      this.AUTH_APPLICATION_ENABLE_DISABLE
    ) {
      this.columns.push({
        title: this.$t('com_table_operation'),
        dataIndex: 'Action',
        width: 120,
        scopedSlots: { customRender: 'Action' },
      });
    }
  },
  methods: {
    // 重置表单
    onSearchReset() {
      this.$refs.formElement.resetFields();
      this.getList();
    },

    // 获取表单数据
    getData() {
      const _list = [this.getList()];

      Promise.all(_list).finally(() => {
        this.$store.commit('setPageLoading', false);
      });
    },

    getList(pageNo) {
      this.pagination.current = pageNo || 1;
      const params = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      };

      this.tableLoading = true;
      this.networkError = false;
      return API.AppList(params)
        .then(res => {
          if (res.code === 0) {
            this.loadSuccess(res);
          }
        })
        .catch(() => {
          this.networkError = true;
        })
        .finally(() => {
          this.loadComplete();
        });
    },

    loadComplete() {
      this.loading = false;
      this.tableLoading = false;
    },

    // 成功
    loadSuccess(res) {
      this.list = res.data || [];

      // total
      this.pagination.total = res.totalCount;
    },

    // 删除
    remove(_$event, record) {
      const _this = this;
      const h = this.$createElement;
      this.$confirm({
        title: this.$t('application_confirm_delete_title'),
        content: h('div', {}, [
          h('p', this.$t('application_confirm_content', { name: record.name })),
        ]),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
          API.AppDel({ id: record.id })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_delete_success'));

                // 重新获取列表
                this.getList(this.pagination.current);
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    /**
     * 启用/禁用 状态
     * @param record
     * @param status true->启用 false->禁用
     */
    setStatus(record, status) {
      const h = this.$createElement;
      this.$confirm({
        title: status
          ? this.$t('application_confirm_enable_title')
          : this.$t('application_confirm_disable_title'),
        content: h('div', {}, [
          h('p', this.$t('application_confirm_content', { name: record.name })),
        ]),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          if (status) {
            this.$store.commit('setFreeze', this.$t('com_ongoing_enable'));
          } else {
            this.$store.commit('setFreeze', this.$t('com_ongoing_disable'));
          }

          API.AppSetStatus({ id: record.id, enable: status })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_success'));

                // 重新获取列表
                this.getList(this.pagination.current);
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
// action
.application-table-action {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
